import { useCallback, useState } from 'react';

export interface ActionErrorMessage {
  title: string;
  message?: string;
  /** Changes on every show, so the same error twice still re-announces. */
  key: number;
}

/** One short-lived failure line for a background action (export, retry, start). */
export const useActionError = () => {
  const [error, setError] = useState<ActionErrorMessage | null>(null);
  const show = useCallback((title: string, message?: string) => setError({ title, message, key: Date.now() }), []);
  const clear = useCallback(() => setError(null), []);
  return { error, show, clear };
};

export type ActionErrorState = ReturnType<typeof useActionError>;
